import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    needsRefresh: false
};
const feedbackSlice = createSlice({
    name: 'feedback',
    initialState,
    reducers: {
        setFeedbackNeedsRefresh: (state, action) => {
            state.needsRefresh = action.payload;
        },
        clearFeedbackRefresh: (state) => {
            state.needsRefresh = false;
        }
    },
});
export const { setFeedbackNeedsRefresh, clearFeedbackRefresh } = feedbackSlice.actions;
export default feedbackSlice.reducer;
export const selectFeedbackNeedsRefresh = (state) => { var _a; return ((_a = state.feedback) === null || _a === void 0 ? void 0 : _a.needsRefresh) || false; };
